import { create } from "zustand";
import { combine, createJSONStorage, persist } from "zustand/middleware";
import { THEME_CONFIG } from "configs/AppConfig";

export const initialState = THEME_CONFIG;

export const themeStore = create(
  persist(
    combine(initialState, (set, get) => ({
      toggleCollapsedNav: (navCollapsed) => set({ navCollapsed }),
      onNavStyleChange: (sideNavTheme) => set({ sideNavTheme }),
      onLocaleChange: (locale) => set({ locale }),
      onNavTypeChange: (navType) => set({ navType }),
      onTopNavColorChange: (topNavColor) => set({ topNavColor }),
      onHeaderNavColorChange: (headerNavColor) => set({ headerNavColor }),
      onMobileNavToggle: (mobileNav) => set({ mobileNav }),
      onSwitchTheme: (currentTheme) => set({ currentTheme }),
      onDirectionChange: (direction) => set({ direction }),
      onBlankLayout: (blankLayout) => set({ blankLayout }),
    })),
    { name: "park-pay-theme", storage: createJSONStorage(() => localStorage) }
  )
);
